<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import type {
    AppointmentPlanningFilterField,
    AppointmentPlanningFilterState,
  } from "../../../../../../_logic/appointments-contract"
  import type { PlanningPreviewSelectOption } from "../../../../_shared/_logic/table-contract"
  import { normalizeAppointmentPlanningDateRange } from "../../_shared/_logic/filters"

  type Props = {
    filters: AppointmentPlanningFilterState
    employeeOptions: PlanningPreviewSelectOption[]
    disabled?: boolean
    dateRangeHint?: string | null
    error?: string | null
    onChange: (
      filters: AppointmentPlanningFilterState,
      field: AppointmentPlanningFilterField,
    ) => void
  }

  let {
    filters,
    employeeOptions,
    disabled = false,
    dateRangeHint = null,
    error = null,
    onChange,
  }: Props = $props()

  const employeeFilterOptions = $derived<PlanningPreviewSelectOption[]>([
    { value: "", label: "Alle Mitarbeiter" },
    ...employeeOptions,
  ])
  const dateRangeInputValue = $derived(
    filters.dateRange.start || filters.dateRange.end ? filters.dateRange : null,
  )

  const eventValue = (event: Event): unknown => {
    const detail = (event as CustomEvent<{ value?: unknown }>).detail

    if (detail && "value" in detail) return detail.value

    return (event.target as HTMLInputElement | HTMLSelectElement | null)?.value ?? ""
  }

  const update = (field: AppointmentPlanningFilterField, value: unknown) => {
    const next: AppointmentPlanningFilterState = {
      ...filters,
      dateRange: filters.dateRange,
    }

    if (field === "search") next.search = String(value ?? "")

    if (field === "employeeId") next.employeeId = String(value ?? "")

    if (field === "dateRange") next.dateRange = normalizeAppointmentPlanningDateRange(value)

    onChange(next, field)
  }
</script>

<div class="appointment-planning-filter-bar form light" aria-label="Terminplanung filtern">
  <div class="row">
    <Input
      type="text"
      placeholder="Suche"
      value={filters.search}
      {disabled}
      onChange={(event) => update("search", eventValue(event))}
    />
    <Input
      type="select"
      placeholder="Mitarbeiter"
      value={filters.employeeId}
      options={employeeFilterOptions}
      {disabled}
      onChange={(event) => update("employeeId", eventValue(event))}
    />
    <Input
      type="dateRange"
      placeholder="Zeitraum"
      value={dateRangeInputValue}
      withTime={false}
      dateGranularity="day"
      {disabled}
      onChange={(event) => update("dateRange", eventValue(event))}
    />
  </div>
  {#if dateRangeHint || error}
    <div class="filter-feedback">
      {#if dateRangeHint}<span>{dateRangeHint}</span>{/if}
      {#if error}<span class="filter-error" role="alert">{error}</span>{/if}
    </div>
  {/if}
</div>

<style lang="less">
  .filter-feedback {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    flex-wrap: wrap;
    margin-top: 0.35rem;
    font-size: 0.78rem;
    color: var(--text-invers-300);
  }

  .filter-error {
    color: var(--error-200, #ff7373);
    font-weight: 700;
  }
</style>
